import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Breadcrumb Component
 * Navigation breadcrumb trail for hierarchical navigation
 */
export default function Breadcrumb({ items = [] }) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="hidden md:block bg-white border-b">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center text-sm text-gray-600">
          {items.map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && <ChevronRight className="w-4 h-4 mx-2" />}
              {index === items.length - 1 ? (
                <span className="text-gray-900">{item.label}</span>
              ) : item.to ? (
                <Link
                  to={item.to}
                  className="hover:text-rose-600 transition"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className="hover:text-rose-600 cursor-pointer transition"
                  onClick={item.onClick}
                >
                  {item.label}
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
